import { IUpdatableNotepad } from "@fokused-me/core";
import { INotepadState, IPanelInfo } from "../../../state/Model";
import { useNotepads } from "../../../state/Notepads";
import { BinContentPanel } from "./BinContentPanel";
import { EditContentPanel } from "./EditContentPanel";
import { NoteContentPanel } from "./NoteContentPanel";
import { TreeContentPanel } from "./TreeContentPanel";

export interface IContentPanelProps {
   notepad?: IUpdatableNotepad;
   notepadState?: INotepadState;
   panelInfo: IPanelInfo;
}

export const ContentPanelSelector = (props: IContentPanelProps) => {
   const { notepads, notepadStates } = useNotepads();

   if (!props.panelInfo) {
      return null;
   }

   switch (props.panelInfo.type) {
      case "tree":
         return (
            <TreeContentPanel
               {...(props as any)}
               notepad={notepads.get(props.panelInfo.notepadId)}
               notepadState={notepadStates.get(props.panelInfo.notepadId)}
            />
         );
      case "bin":
         return (
            <BinContentPanel
               {...(props as any)}
               notepad={notepads.get(props.panelInfo.notepadId)}
               notepadState={notepadStates.get(props.panelInfo.notepadId)}
            />
         );
      case "note":
         return (
            <NoteContentPanel
               {...(props as any)}
               notepad={notepads.get(props.panelInfo.notepadId)}
               notepadState={notepadStates.get(props.panelInfo.notepadId)}
            />
         );
      case "edit":
         return (
            <EditContentPanel
               {...(props as any)}
               notepad={notepads.get(props.panelInfo.notepadId)}
               notepadState={notepadStates.get(props.panelInfo.notepadId)}
            />
         );
      default:
         return null;
   }
};
